import { FlowTypes, MobileDeviceValues } from "@trailhead/smart-setup-core";
import { FactoryTypes, FieldID } from "../../../models";

export const iphoneSendBackContent = {
  criteria: {
    oldPhone: MobileDeviceValues.iPhone,
    oldDeviceAccess: true,
    deviceFlowType: FlowTypes.Replacement,
  },
  content: [
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.tipReturnOldDevice,
        icon: FieldID.guideContainer.tipBox.icon,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.stepSendUsYourIPhone.text,
      },
    },
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.tipSIMNotAccessible,
        icon: FieldID.guideContainer.tipBox.iconV2,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.stepDisableFindMyIphone.text,
      },
    },
    {
      type: FactoryTypes.DECISION_STEP,
      fieldMapping: {
        yesButtonText:
          FieldID.guideContainer.decisionStep.introHeaderGuideIos13,
        noButtonText: FieldID.guideContainer.decisionStep.headerGuideOlderIos,
        buttonVariant: "flat",
        yesSteps: [
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepOpenIphoneSettings.text,
              image: FieldID.guideContainer.steps.stepOpenIphoneSettings.image,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepSettingsTapYourName.text,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepFindMyIcon.text,
              image: FieldID.guideContainer.steps.stepFindMyIcon.image,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepFindMyIphoneOffOn.text,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepFindMyIphoneToggleSwitch
                .text,
              image:
                FieldID.guideContainer.steps.stepFindMyIphoneToggleSwitch.image,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepAppleIdPasswordTurnOff
                .text,
              image:
                FieldID.guideContainer.steps.stepAppleIdPasswordTurnOff.image,
            },
          },
          {
            type: FactoryTypes.EXPERT_HELP,
            fieldMapping: {
              buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
              title: FieldID.guideContainer.expertHelpContent.title,
              subtext: FieldID.guideContainer.expertHelpContent.subtext,
              secondaryButtonText:
                FieldID.guideContainer.expertHelpContent.secondaryButtonText,
              supportNumber:
                FieldID.guideContainer.expertHelpContent.supportNumber,
              icon: FieldID.guideContainer.expertHelpContent.icon,
            },
          },
        ],
        noSteps: [
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepOpenIphoneSettings.text,
              image: FieldID.guideContainer.steps.stepOpenIphoneSettings.image,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepSettingsTapYourName.text,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.stepFindMyIcon.text,
              image: FieldID.guideContainer.steps.stepFindMyIcon.image,
              shouldInlineTextAndImage: true,
            },
          },
          {
            type: FactoryTypes.STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.turnOffIPhoneStep.text,
            },
          },
          {
            type: FactoryTypes.EXPERT_HELP,
            fieldMapping: {
              buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
              title: FieldID.guideContainer.expertHelpContent.title,
              subtext: FieldID.guideContainer.expertHelpContent.subtext,
              secondaryButtonText:
                FieldID.guideContainer.expertHelpContent.secondaryButtonText,
              supportNumber:
                FieldID.guideContainer.expertHelpContent.supportNumber,
              icon: FieldID.guideContainer.expertHelpContent.icon,
            },
          },
        ],
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.stepUspsTrackingOnPhoneClaim.text,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.stepSealedUspsAvoidFee.text,
      },
    },
  ],
};
